export default process.env.VUE_APP_MOBIMED_URL || ''
